import React, { Fragment, useEffect, useState } from 'react';
import { BUSINESS_STRUCTURES, BUSINESS_TYPES } from './businessTypes';
import RawSelector, { SelectorOption } from '../../RawSelector';

const formatBusinessStructureOptions = (
  selectedBusinessType?: string,
  selectedBusinessStructure?: string,
): SelectorOption[] =>
  BUSINESS_STRUCTURES[selectedBusinessType || BUSINESS_TYPES[0].value].map(
    (fbso) => ({
      ...fbso,
      selected: fbso.value === selectedBusinessStructure,
    }),
  );

export default function BusinessTypeDropdowns({
  onTypeChange,
  onStructureChange,
}: {
  onTypeChange: (type: string) => void;
  onStructureChange: (structure: string) => void;
}): JSX.Element {
  const [selectedBusinessType, setSelectedBusinessType] = useState<string>(
    BUSINESS_TYPES[0].value,
  );
  const [selectedBusinessStructure, setSelectedBusinessStructure] =
    useState<string>(BUSINESS_STRUCTURES[BUSINESS_TYPES[0].value][0].value);
  const [
    formattedBusinessStructureOptions,
    setFormattedBusinessStructureOptions,
  ] = useState<SelectorOption[]>(
    formatBusinessStructureOptions(
      selectedBusinessType,
      selectedBusinessStructure,
    ),
  );

  const changeStructure = (structure: string): void => {
    setSelectedBusinessStructure(structure);
    onStructureChange(structure);
  };

  const handleBusinessTypeChange = (value?: string): void => {
    if (value === undefined) {
      return;
    }
    if (value !== selectedBusinessType) {
      setSelectedBusinessType(value);
      onTypeChange(value);
      // when type changes set structure to first value
      const newStructure = BUSINESS_STRUCTURES[value][0];
      changeStructure(newStructure.value);
    }
  };

  const handleStructureChange = (value?: string): void => {
    if (value === undefined) {
      return;
    }
    if (value !== selectedBusinessStructure) {
      changeStructure(value);
    }
  };

  const formattedBusinessTypeOptions =
    selectedBusinessType !== undefined
      ? BUSINESS_TYPES.map((bt) => ({
          ...bt,
          selected: selectedBusinessType === bt.value,
        }))
      : BUSINESS_TYPES;

  useEffect(() => {
    setFormattedBusinessStructureOptions(
      formatBusinessStructureOptions(
        selectedBusinessType,
        selectedBusinessStructure,
      ),
    );
  }, [selectedBusinessStructure, selectedBusinessType]);

  return (
    <Fragment>
      <div className='my-2 md:w-1/3'>
        <RawSelector
          label='Business Type'
          options={formattedBusinessTypeOptions}
          onChange={handleBusinessTypeChange}
        />
      </div>
      <div className='my-2 md:w-1/3'>
        <RawSelector
          label='Structure'
          options={formattedBusinessStructureOptions}
          onChange={handleStructureChange}
        />
      </div>
    </Fragment>
  );
}
